import { PurchaseOrderDetailPanel } from './PurchaseOrderDetailPanel';

export default PurchaseOrderDetailPanel;
